import enviro from 'enviro';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FeedbackSurveyFooter from 'growth-onboarding-feedback-components/components/FeedbackSurveyFooter';
import FeedbackSurveyModal from 'growth-onboarding-feedback-components/components/FeedbackSurveyModal';
import { addSuccessAlert } from 'growth-payments-core/alerts';
import { track } from 'growth-payments-core/usage-tracker/track';
import { events } from 'growth-payments-core/usage-tracker/events';

/**
 * @returns {number} payments drop-off survey id
 * QA   : https://app.hubspotqa.com/feedback/100765651/satisfaction/194/submissions
 * PROD : https://app.hubspot.com/feedback/53/satisfaction/640/submissions
 */
import { jsx as _jsx } from "react/jsx-runtime";
const getExitOnboardingSurveyId = () => {
  return enviro.isQa() ? 194 : 640;
};
const NativeCancelSurvey = ({
  closeModal
}) => {
  const surveyId = getExitOnboardingSurveyId();
  return /*#__PURE__*/_jsx(FeedbackSurveyModal, {
    footer: /*#__PURE__*/_jsx(FeedbackSurveyFooter, {
      confirmText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelSurvey.submit"
      }),
      onConfirm: () => {
        track(events.paymentSettingsInteraction, {
          action: 'submitCancelSurvey'
        });
        closeModal();
        addSuccessAlert({
          title: 'CancelSurvey.alert.title',
          message: 'CancelSurvey.alert.message'
        });
      },
      onReject: () => {
        track(events.paymentSettingsInteraction, {
          action: 'rejectCancelSurvey'
        });
        closeModal();
      },
      rejectText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelSurvey.cancel"
      }),
      surveyConfig: undefined
    }),
    onOpenComplete: () => track(events.paymentSettingsInteraction, {
      action: 'openCancelSurvey'
    }),
    placeholder: I18n.text('CancelSurvey.placeholder'),
    subTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CancelSurvey.description"
    }),
    surveyId: surveyId,
    surveyType: "CSAT",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CancelSurvey.header"
    })
  });
};
export default NativeCancelSurvey;